import { Carousel } from 'react-responsive-carousel';

import './ImageGallery.css';
const ImageGallery = ({ imageList, selectedItem, onItemChange }) => {
  return (
    <div className="image-gallery">
      <Carousel
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        transitionTime={500}
        onChange={(index) => onItemChange(index)}
        selectedItem={selectedItem}
        preventMovementUntilSwipeScrollTolerance={true}
        swipeScrollTolerance={100}
        swipeable
        renderIndicator={(clickHandler, isSelected, index, label) => {
          return (
            <span
              onClick={clickHandler}
              className={isSelected ? 'ellipsis-selected' : 'ellipsis-unselected'}
            />
          );
        }}
      >
        {imageList.map((image, i) => (
          <img src={image} key={i} style={{ borderRadius: '4px', overflow: 'hidden' }} />
        ))}
      </Carousel>
    </div>
  );
};

export default ImageGallery;
